import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
const Navbar = () => {
  // const navigate = useNavigate();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  // const [showDropdown, setShowDropdown] = useState(false);
  const [openPop, setOpenPop] = useState(false);

  useEffect(() => {
    setOpenPop(false);
  }, []);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClose = () => {
    setOpenPop(false);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light p-3">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img
              src="/images/logo.webp"
              alt="Logo"
              className="img-fluid"
              loading="lazy"
              style={{ width: '100px' }}
            />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNavbar} // Toggle the collapse state
            aria-controls="navbarNav"
            aria-expanded={isNavbarOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`}
            id="navbarNav"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <NavLink
                  exact
                  className="nav-link"
                  to="/"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/about"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/service"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/works"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Works
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/blog"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Blog
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/two-days-mvp"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  2 Days Website
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/fellowship"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Fellowship
                </NavLink>
              </li>
              {/* <li
                className="nav-item dropdown"
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                style={{ position: 'relative' }}
              >
                <span
                  className={`nav-link ${showDropdown ? 'active' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => e.preventDefault()}
                >
                  Amizhth Express ▾
                </span>
                {showDropdown && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      backgroundColor: 'white',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                      borderRadius: 1,
                      zIndex: 10,
                      minWidth: 180,
                      overflow: 'hidden',
                      animation: 'fadeIn 0.3s ease'
                    }}
                  >
                    <Box
                      sx={{
                        py: 1,
                        px: 2,
                        cursor: 'pointer',
                        borderBottom: '1px solid #e0e0e0',
                        '&:hover': { backgroundColor: '#f5f5f5' }
                      }}
                      onClick={() => {
                        navigate('/two-days-mvp');
                        closeNavbar();
                        setShowDropdown(false);
                        scrollToTop();
                      }}
                    >
                      2 Days MVP
                    </Box>
                    <Box
                      sx={{
                        py: 1,
                        px: 2,
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#f5f5f5' }
                      }}
                      onClick={() => {
                        navigate('/ten-days-mvp');
                        closeNavbar();
                        setShowDropdown(false);
                        scrollToTop();
                      }}
                    >
                      10 Days MVP
                    </Box>
                  </Box>
                )}
              </li> */}
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/contact"
                  activeClassName="active"
                  onClick={() => {
                    closeNavbar();
                    scrollToTop();
                  }}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <Dialog
        // fullWidth={true}
        maxWidth={'sm'}
        open={openPop}
        onClose={handleClose}
      >
        <Link to={'https://forms.gle/kgqx1y5LbTCMrbkE9 '} target="_blank">
          {' '}
          <img
            src="./images/popup.jpeg"
            alt=""
            className="popupCss img-fluid"
          />
        </Link>
        <CloseIcon className="closeIconCss" onClick={handleClose} />
      </Dialog>
    </>
  );
};

export default Navbar;
